namespace $ {
	/** Explicit folders only. Corrupt ancestry cannot hide entries or recurse forever. */
	export class $shm_hitalama_skills_tree {
		readonly roots: string[] = []
		readonly nodes = new Map<string, string[]>()
		readonly parents = new Map<string, string>()
		constructor( entries: readonly { id: string, parent: string, group: boolean }[], orders: ReadonlyMap<string, readonly string[]> = new Map ) {
			const groups = new Set( entries.filter( item => item.group ).map( item => item.id ) )
			const parents = new Map( entries.map( item => [ item.id, item.parent ] ) )
			for( const item of entries ) this.nodes.set( item.id, [] )
			for( const item of entries ) {
				let parent = groups.has( item.parent ) ? item.parent : ''
				const seen = new Set([ item.id ])
				for( let cursor = item.group ? parent : ''; cursor; cursor = parents.get( cursor ) ?? '' ) {
					if( seen.has( cursor ) ) { parent = ''; break }
					seen.add( cursor )
				}
				this.parents.set( item.id, parent )
				;( parent ? this.nodes.get( parent )! : this.roots ).push( item.id )
			}
			for( const [ id, siblings ] of [ [ '', this.roots ] as const, ...this.nodes ] ) {
				const order = orders.get( id ) ?? [], ranks = new Map( order.map( ( id, i )=> [ id, i ] ) )
				siblings.sort( ( a, b )=> ( ranks.get( a ) ?? order.length ) - ( ranks.get( b ) ?? order.length ) )
			}
		}
		children( id: string ) { return this.nodes.get( id ) ?? [] }
	}
}
